export const experience = [
  {
    id: "tomasi-tech-lead",
    role: "Software Engineer",
    company: "Tomasi Design",
    period: "2024 — Present",
    achievements: [
      "Owned the technical implementation and cloud architecture for the company's e-commerce platform, migrating from a monolithic deployment to a cloud-native AWS architecture.",
      "Reduced first page load by 48% introducing CloudFront caching and Reduced s3 costs by 60% using Image Optimization pipelines.",
      "Built and shipped an image compression service on AWS Lambda, cutting storage costs and improving delivery speed.",
      "Own end-to-end infrastructure decisions: CI/CD, deployment strategy, monitoring, and cost optimization.",

      "Took Tomasi from an offline concept to a production-ready online platform by building and owning the complete technical ecosystem.",
      "Defined the company's technical architecture, establishing engineering standards centered around robustness, simplicity, and maintainability.",
      "Built scalable cloud infrastructure and deployment pipelines that minimized operational overhead while maximizing performance and cost efficiency.",
      "Owned end-to-end AWS infrastructure, including CI/CD, deployments, monitoring, security, and cost optimization.",
    ],
  },
];
